<template>
  <div
    class="p-j-message-article-panel-body p-j-message-article-panel-body--col"
  >
    <div class="p-j-message-article-panel-body__user-data">
      <div class="p-j-message-article-panel-body__user-line">
        <div class="p-j-message-article-panel-body__name" data-translate-skip>
          {{ name }}
        </div>
        <div class="p-j-message-article-panel-body__id" data-translate-skip>
          ID:{{ id }}
        </div>
        <div class="p-j-message-article-panel-body__group" data-translate-skip>
          {{ groupName }}
        </div>
      </div>
    </div>
    <div class="p-j-message-article-panel-body__content">
      <p class="message-link" data-translate-skip>{{ truncate(content, 62) }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import SmallText from "@/common/components/atoms/SmallText.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	detailData: { type: Object, default: () => ([]) },
	unreadCountIsExists: { type: Boolean, default: () => ([]), required: false }
  },
  components: {
    SmallText
  }
})
export default class JMessageArticlePanelBody extends Vue {
  detailData!: any;
  unreadCountIsExists!: boolean;

  get name() {
    if (this.detailData.isDeleted) {
      return "‐"
    }
    return this.detailData.name;
  }

  get unreadCount() {
    return this.detailData.unreadCount;
  }

  get content() {
    return this.detailData.content;
  }

  get id() {
    return this.detailData.id;
  }

  get groupName() {
    if (this.detailData.isDeleted) {
      return "　"
    }
    return this.detailData.groupName;
  }

  truncate(value: any, length = 20, omission = "...") {
    // if (length === false) {
    //   return value;
    // }
    const stringLength = parseInt(length.toString(), 10);
    const stringOmmision = omission.toString();

    if (value.length <= stringLength) {
      return value;
    }
    return value.substring(0, stringLength) + stringOmmision;
  }
}
</script>

<style lang="scss" scoped>
.p-j-message-article-panel-body {
  @include pc {
    width: calc(100% - 15.875rem);
  }
  @include sp {
    width: calc(100% - 3rem);
    min-width: 0;
  }

  &--col {
    @include pc {
      display: flex;
      align-items: center;
    }
  }

  &__user-data {
    @include pc {
      width: rem(300);
      min-width: rem(300);
    }
  }

  &__content {
    @include pc {
      width: calc(100% - 18.875rem);
      flex-grow: 1;
      padding-left: rem(8);
    }
    @include sp {
    }
    font-size: rem(14);
    line-height: 1.6;
    display: block;

    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: block;
    }
  }
}

.message-link:hover {
  color: #075cce;
}

.p-j-message-article-panel-body__user-data {
  min-width: 0;
  @include pc {
    width: rem(300);
    min-width: rem(300);
  }
  text-align: left;
}

.p-j-message-article-panel-body__user-line {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.p-j-message-article-panel-body__name {
  font-size: rem(16);
  font-weight: 500;
  text-align: left;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.p-j-message-article-panel-body__id,
.p-j-message-article-panel-body__group {
  margin-left: 0;
  font-size: rem(12);
  color: $common-gray500;
}
.p-j-message-article-panel-body__id {
  margin-bottom: 4px;
}
.p-j-message-article-panel-body__group {
  @include sp {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
}
</style>
